<template>
  <div class="information-tab">
    <page-title-area>
      <h1>INFORMATION</h1>
    </page-title-area>
    <announcement-list-skeleton
      v-if="loadingAnnouncements"
      data-testid="announcement-skeleton"
    />
    <announcement-list
      v-else
      :announcements="announcements"
    />
    <document-list-skeleton
      v-if="loadingDocuments"
      data-testid="documents-skeleton"
    />
    <template v-else>
      <template v-for="sensorType in sensorTypesInOrder">
        <document-list
          v-if="documents[sensorType]"
          :key="sensorType"
          :sensorType="sensorType"
          :documents="documents[sensorType]"
        />
      </template>
    </template>
  </div>
</template>

<script>
import PageTitleArea from '@/components/atoms/PageTitleArea';
import SensorTypes from '@/mixins/sensorTypes';
import Notifications from '@/mixins/notifications';

import DocumentList from './DocumentList';
import DocumentListSkeleton from './DocumentListSkeleton';
import AnnouncementList from './AnnouncementList';
import AnnouncementListSkeleton from './AnnouncementListSkeleton';

export default {
  name: 'information-tab',
  mixins: [SensorTypes, Notifications],
  inject: ['api', 'announcement'],
  components: {
    AnnouncementList,
    AnnouncementListSkeleton,
    DocumentList,
    DocumentListSkeleton,
    PageTitleArea,
  },
  data() {
    return {
      documents: {},
      announcements: [],
      loadingDocuments: true,
      loadingAnnouncements: true,
    };
  },
  computed: {
    sensorTypesInOrder() {
      return [
        this.SENSOR_TYPES.FLY,
        this.SENSOR_TYPES.FLY_COUNT,
        this.SENSOR_TYPES.RAT,
        this.SENSOR_TYPES.STATION,
      ];
    },
  },
  methods: {
    async loadDocuments() {
      try {
        this.documents = await this.api.fetchDocuments();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch documents:', e);
        this.notifyError('error.fetch_documents');
      } finally {
        this.loadingDocuments = false;
      }
    },
    async loadAnnouncements() {
      try {
        this.announcements = await this.api.fetchAnnouncements();
        this.announcement.markAsRead();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch announcements:', e);
        this.notifyError('error.fetch_announcements');
      } finally {
        this.loadingAnnouncements = false;
      }
    },
  },
  async mounted() {
    await Promise.all([
      this.loadDocuments(),
      this.loadAnnouncements(),
    ]);
  },
};
</script>

<style lang="sass" scoped>
</style>

<i18n lang="yaml">
ja:
  error:
    fetch_documents: ドキュメントの取得に失敗しました
    fetch_announcements: お知らせの取得に失敗しました
en:
  error:
    fetch_documents: Failed to fetch documents
    fetch_announcements: Failed to fetch announcements
</i18n>
